import { tools } from "@/mocks/home";

export default function ToolCompare() {
  return (
    <section id="tools" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-secondary-700 uppercase">
            Tool Compare
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            下载与网盘工具对比
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            同样是下载，网盘客户端与 BT 客户端的定位并不相同。下面按类型、核心用途、常用格式、会员情况与适合人群五个维度做了对比，
            方便你按自己的习惯挑选工具。
          </p>
        </div>

        <div className="mt-8 overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full min-w-[760px] border-collapse text-left">
            <thead>
              <tr className="bg-background-200/70">
                <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">工具名称</th>
                <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">类型</th>
                <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">核心用途</th>
                <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">常用格式</th>
                <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">会员情况</th>
                <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">适合人群</th>
              </tr>
            </thead>
            <tbody>
              {tools.map((tool) => (
                <tr key={tool.name} className="border-t border-background-200 hover:bg-background-100 transition-colors">
                  <th scope="row" className="px-4 py-4 align-top">
                    <span className="flex items-center gap-2.5">
                      <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                        <i className={`${tool.icon} text-lg`}></i>
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-950 whitespace-nowrap">{tool.name}</span>
                    </span>
                  </th>
                  <td className="px-4 py-4 align-top text-sm text-foreground-700 whitespace-nowrap">{tool.type}</td>
                  <td className="px-4 py-4 align-top text-sm text-foreground-700">{tool.core}</td>
                  <td className="px-4 py-4 align-top text-sm text-foreground-600 whitespace-nowrap">{tool.formats}</td>
                  <td className="px-4 py-4 align-top text-sm text-foreground-600 whitespace-nowrap">{tool.member}</td>
                  <td className="px-4 py-4 align-top">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium whitespace-nowrap">
                      {tool.fit}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-foreground-500">
          表格仅用于说明工具定位差异，不构成任何推荐或授权。请遵守各软件与平台的用户协议。
        </p>
      </div>
    </section>
  );
}